import styled from "styled-components";

export const CorperateEmailSettingFormStyled = styled.div`
  .form_title {
    margin-bottom: 1rem;
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .group_wrap {
    margin-bottom: 1.5rem;
    .group_label {
      margin: 0 0 0.75rem 1rem;
    }
    .email_row {
      margin-bottom: 0.75rem;
      margin-left: 135px;
      max-width: 470px;
      display: flex;
      align-items: center;
      column-gap: 1rem;
      .er_col {
        flex: 1;
      }
      .btn_delete {
        cursor: pointer;
      }
    }
    .w130 {
      width: 130px;
    }
  }
  .action_row {
    margin-top: 2rem;
    display: flex;
    justify-content: flex-end;
    column-gap: 10px;
    .w130 {
      width: 130px;
    }
  }
`;
